import { render, staticRenderFns } from "./AlternateValuesChipEditor.vue?vue&type=template&id=2c9036f9&scoped=true&"
import script from "./AlternateValuesChipEditor.vue?vue&type=script&lang=js&"
export * from "./AlternateValuesChipEditor.vue?vue&type=script&lang=js&"
import style0 from "./AlternateValuesChipEditor.vue?vue&type=style&index=0&id=2c9036f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9036f9",
  null
  
)

export default component.exports